module.exports = __webpack_public_path__ + "img/20200613_141828.f8f5625e.jpg";